import moment from "moment-timezone";
export default function () {
  return {
    items: {
      data: [],
      columns: [
        {
          name: "CUSTOMER NAME",
          align: "left",
          label: "CUSTOMER NAME",
          field: (row) => row.company,
        },
        {
          name: "COACHING TRACK",
          align: "left",
          label: "COACHING TRACK",
          field: (row) => row.coaching_track_title,
        },
        {
          name: "SESSION",
          align: "left",
          label: "SESSION",
          field: (row) => row.order_no,
        },
        {
          name: "SESSION DATE",
          align: "left",
          label: "SESSION DATE",
          field: (row) => moment(row.start_datetime).format("MMM Do YYYY"),
        },
        {
          name: "SESSION TIME",
          align: "left",
          label: "SESSION TIME",
          field: (row) => moment(row.start_datetime).format("LT"),
        },
        { name: "actions", align: "left", label: "JOIN SESSION" },
      ],
      pagination: {
        sortBy: "",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        totalRecords: 0,
      },
      filter: {
        search: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
      },
      lastUpdated: "",
    },
  };
}
